const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate performAtDatabaseBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const clientInfoSource = {
    type: 'clientInfoBehavior'
  };
  const clientInfo = await evaluateSource(clientInfoSource, content, parentContentPath, transientContext, nativeFunctions);
  const performType = clientInfo.clientType === 'web' ? 'performOnServerBehavior' : 'performBehavior';
  const performSource = {
    type: performType,
    actions: source.actions
  };
  return evaluateSource(performSource, content, parentContentPath, transientContext, nativeFunctions);
};
module.exports = {
  evaluate
};